const DEFAULT_ADD_TO_CART = { tag: 'product-quantity-toggle' } as const;

export const applyChatMessengerRichContentConfig = (): void => {
  const rc = window.chatMessengerRichContent;
  if (!rc?.setRichContentConfig) return;

  if (typeof rc.getRichContentConfig === 'function') {
    const existing = rc.getRichContentConfig() as Record<string, unknown>;
    const prevTile =
      existing.tileConfig && typeof existing.tileConfig === 'object' && existing.tileConfig !== null
        ? (existing.tileConfig as Record<string, unknown>)
        : {};
    const addToCart =
      existing.addToCart && typeof existing.addToCart === 'object' && existing.addToCart !== null
        ? (existing.addToCart as { tag: string })
        : DEFAULT_ADD_TO_CART;

    rc.setRichContentConfig({
      ...existing,
      addToCart,
      tileConfig: { ...prevTile, usesRichContentConfig: true },
    });

    return;
  }

  rc.setRichContentConfig({
    addToCart: DEFAULT_ADD_TO_CART,
    tileConfig: { usesRichContentConfig: true },
  });
};
